import React from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import * as firebase from 'firebase';
import '../view/css/DeleteAccountModal.css';
import { useHistory } from "react-router-dom";
import { createMuiTheme, responsiveFontSizes, ThemeProvider } from '@material-ui/core/styles';


import { v4 as uuidv4 } from 'uuid';

import {
    BrowserRouter as Router,
    Switch,
    Route,
    withRouter,
    Link,
    Redirect
  } from "react-router-dom";
import { red } from '@material-ui/core/colors';

const theme = createMuiTheme({
  typography: {
      fontFamily: 'Rubik',
      fontSize: 14.5,
  },
});

export const DeleteAccountModal = (props) => {
    const [open, setOpen] = React.useState(false);
    const [password, setPassword] = React.useState("");
    const [passwordInput, setPasswordInput] = React.useState("");
    const [error, setError] = React.useState(false);
    const [id, setId] = React.useState("");

    const firestore = firebase.firestore();
    let history = useHistory();

    
    const handleClickOpen = () => {
        setOpen(true);
        setPassword(props.password);
    };

    const handleClose = () => {
        setOpen(false);
        setError(false);
        setPassword("");
        setPasswordInput("");
    };

    const inputPassword = (e) => {
        setPasswordInput(e.target.value);
    }


    const deleteAccount = async () => {
      // Delete the account
  
      if (password != passwordInput) {
        setError(true);
        return;
      } else {
        setError(false);
      }

      if (props.type == "Student") {
        const docRef = firestore.collection("Users").doc(props.email);
        let doc = await docRef.get();
        if(doc.exists){
        const subArray = doc.data().subscriptions;
        subArray.map( (sub) => {
          let docRef2 = firestore.collection("Users").doc(sub);
          docRef2.update({
            "students": firebase.firestore.FieldValue.arrayRemove(props.email)
          })
          
        })
      }

        // Deletes the student doc
        firestore.collection("Users").doc(firebase.auth().currentUser.email).delete().then(function() {
          console.log("Document successfully deleted!");
        }).catch(function(error) {
          console.error("Error removing document: ", error);
        });
      }


       if (props.type == "Affiliate") {
        const docRef = firestore.collection("Users").doc(props.email);
         let doc = await docRef.get();
        const subArray = doc.data().students;
        subArray.map( (sub) => {
           let docRef2 = firestore.collection("Users").doc(sub);
          docRef2.update({
           "subscriptions": firebase.firestore.FieldValue.arrayRemove(props.email)
         })
        })
        const array_events = doc.data().events;
        const this_check = firestore.collection("Event");
        console.log(array_events);
        if(array_events.length != undefined){
          console.log('deleteooga')
        for(var i =0; i <array_events.length;i++){
          console.log(array_events[i].id);
          this_check.doc(array_events[i].id).delete().then(function() {
            console.log("Document successfully deleted!");
        }).catch(function(error) {
            console.error("Error removing document: ", error);
        });
        }
      }
      firestore.collection("Users").doc(props.email).delete().then(function() {
        console.log("Document successfully deleted!");
      }).catch(function(error) {
        console.error("Error removing document: ", error);
      });
        
       }

      // Deletes auth
      firebase.auth().currentUser.delete().then(function() {
        console.log("User Deleted");
        history.push('/')
      }).catch(function(error) {
        console.log("Error in deleting user")
      });
      handleClose();
    }

    return (
        <div>
            <button className="DeleteAccountButton" onClick={handleClickOpen}>
                Delete Account
      </button>
      <ThemeProvider theme={theme}>
            <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
                <DialogTitle className="alert1">All account information will be permanently deleted.</DialogTitle>
                <DialogTitle className="alert2">Please confirm you wish to continue with deleting this account by entering your password below.</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        {error && <i>Password is incorrect! Please try again.</i>}
                    </DialogContentText>
                    <form>
                        
                        <TextField
                            //autoFocus
                            margin="dense"
                            id="password"
                            label="Confirm Password"
                            type="password"
                            fullWidth
                            onChange={inputPassword}
                            value={passwordInput}
                        />
                        
                    </form>

                </DialogContent>
                <DialogActions>
                    <Button onClick={deleteAccount} color="primary">
                        Confirm Delete
                    </Button>
                    <Button onClick={handleClose} color="primary">
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
            </ThemeProvider>
        </div>
    );
}